export enum FormParams {
    COUNTRY_FILTER = "countryFilter",
    STATE_FILTER = "stateFilter",
    MIN_LOCATION_COUNT = "minLocationCount",
    MAX_LOCATION_COUNT = "maxLocationCount",
    EXCLUDE_DISTRIBUTORS = "excludeDistributors",
    COLUMNS = "columns",
    USE_LIST_COLUMNS = "useListColumns",
    SIC_CODES = "sicCodes",
    NAICS_CODES = "naicsCodes",
    CATEGORIES = "categories",
    LISTIDS = "listIds",
    ADD_TRACKED_LISTS = "addTrackedLists",
    NAME = "name",
    LISTS = "lists",
    ADD_SNAPSHOTS = "addSnapshots",
    DOWNLOAD_AS = "downloadAs",
    SPLIT_FILES = "splitFiles",
    INCLUDE_UPDATED_ONLY = "includeUpdatedOnly",
    PRIMARY_NAICS_CODE_ONLY = "primaryNaicsCodesOnly",
    SNAPSHOT_DATES = "snapshotDates",
    SNAPSHOT_DATE = "snapshotDate",
    TOLERANCE = "tolerance",
    TOLERANCE_PERIOD = "tolerancePeriod",
    TOLERANCE_RANGE = "toleranceRange",
    SET_FREQUENCY = "setFrequency",
}
